import { useCallback, useMemo, useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { mediaService } from 'shared/services/mediaService';
import { profileService } from 'shared/services/profileService';
import { imageURLtoFile, isJsonString } from 'shared/utils/common';
import { useDebounce } from 'use-debounce';
import { v4 as uuidv4 } from 'uuid';

const { getMediaTags } = mediaService();

const useImagesHelper = () => {
  const [queryValue] = useDebounce('', 500);
  const { data: mediaTags, isLoading: fetchingTags } = getMediaTags(queryValue);
  const [files, setFiles] = useState<File[]>([]);
  const [showEdit, setShowEdit] = useState(false);
  const { getProfilesGraphQL } = profileService();
  const { data } = getProfilesGraphQL('');
  const primaryId = useMemo(() => {
    return data?.data.profiles?.find((f) => f.primary)?.id;
  }, [data]);
  const [fetchingImageUrlToFile, setFetchingImageUrlToFile] = useState(false);

  const openEditor = (files: File[]) => {
    setFiles(files);
    setShowEdit(true);
  };

  const convertImageUrlsToFiles = useCallback((media: IMedia[]) => {
    const prepareFiles: Promise<File>[] = [];
    media.forEach((currentMedia) => {
      const setName = isJsonString(currentMedia.attributes.file_name)
        ? JSON.parse(currentMedia.attributes.file_name).filename
        : uuidv4();
      const filename = JSON.stringify({
        name: setName,
        id: currentMedia.id,
      });
      prepareFiles.push(imageURLtoFile(currentMedia.attributes.attachment_url, filename));
    });
    setFetchingImageUrlToFile(true);
    Promise.all(prepareFiles).then((files) => {
      openEditor(files);
      setFetchingImageUrlToFile(false);
    });
  }, []);

  const onEdit = (media: IMedia[]) => {
    convertImageUrlsToFiles(media);
  };

  return {
    primaryId,
    files,
    showEdit,
    fetchingImageUrlToFile,
    onEdit,
    setShowEdit,
    setFetchingImageUrlToFile,
    mediaTags,
    fetchingTags,
    openEditor,
  };
};

export default useImagesHelper;
